// import the vuex module for localization
import identityVuexModule from './vuex-identity-store';

// import the corresponding plugin for vue
import VuexIdentityPlugin from './vuex-identity-plugin';

// export both modules as one file
export default {
    store: identityVuexModule,
    plugin: VuexIdentityPlugin
};



// WEBPACK FOOTER //
// ./src/identity/index.js